import { render, staticRenderFns } from "./RNoResultsMessage.vue?vue&type=template&id=196985ee&"
import script from "./RNoResultsMessage.vue?vue&type=script&lang=js&"
export * from "./RNoResultsMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports